<template>
  <div class="full-container-page display-col full-height">
<!--    <div class="breadcrumb-container" v-if="showBreadCrumb=='1'&&canReturn=='0'">-->
<!--&lt;!&ndash;        <BreadCrumb></BreadCrumb>&ndash;&gt;-->
<!--    </div>-->
<!--    <div class="breadcrumb-container editBread-container" v-if="showBreadCrumb=='1'&&canReturn=='1'">-->
<!--&lt;!&ndash;        <slot name="editBreadcrumb"></slot>&ndash;&gt;-->
<!--    </div>-->
    <div class="search-container">
      <slot name="search"></slot>
    </div>
    <div class="full-container flex1">
        <slot name="full"></slot>
    </div>
  </div>
</template>

<script>
import BreadCrumb from './layout/components/breadCrumb'
export default {
  data() {
      return{

      }
  },
  components:{BreadCrumb},
  props:{
    canReturn:{
      default:'0'
    },
    showBreadCrumb:{
       default:'1'
    }
  },
  methods: {
    
  },
  created() {
  }
};
</script>

<style lang="less" scoped>
.full-container-page{
  overflow: auto!important;

}
.search-container{
  // height: 120px;
  background-color: #fff;
  padding: 10px;
}
.editBread-container{
  padding-bottom: 10px;
}
.full-container{
  // margin-top: 10px;
  padding: 10px;
  // overflow: hidden;
  background-color: #fff;
  border-radius: 5px;
}
    
</style>
